/**
 * The migration chain: every step that exists, in order.
 *
 * One import and one entry per step, and nothing else. A step is a file under `migrations/`, never
 * a case in a switch here, so the chain stays a list of what exists rather than a second place the
 * work is described.
 *
 * Bumping `SAVE_SCHEMA_VERSION` without adding the step that reaches it makes every existing save
 * fail with `noMigrationPath`, loudly, on load. That is the intended failure.
 */

import { ADD_PROGRESSION } from '@/save/migrations/addProgression';
import { ADD_SETTINGS } from '@/save/migrations/addSettings';
import { RENAME_WEAPON_IDS } from '@/save/migrations/renameWeaponIds';
import type { SaveMigration } from '@/save/migrationContract';

/** Ordered by `from`, ascending and contiguous. `runMigrations` fails on any gap. */
export const SAVE_MIGRATIONS: readonly SaveMigration[] = [
  ADD_PROGRESSION,
  ADD_SETTINGS,
  RENAME_WEAPON_IDS,
];
